export const environment = {

  production: true,
  environmentType: 'uat',

  web: {
    baseUrl: '//studio.uat.mtm.video',
    avatarUrl: 'https://storage.googleapis.com/mtmvideo-uat-v2/%COMPANYID%/%USERNAME%/avatar?alt=media',
  },

  api: {
    baseUrl: 'https://gateway.studio.uat.mtm.video',
    mockapiUrl: '//58c14598e8215412002f7cf5.mockapi.io',
    analyticsUrl: 'https://analytics.studio.uat.mtm.video'
  },

  adminConsole: {
    baseUrl: 'https://admin.ui.studio.uat.mtm.video',
    authPath: '/auth/sso-callback'
  },

  adminStudio: {
    baseUrl: 'https://admin.studio.uat.mtm.video',
  },

  websocket: {
    chatBaseUrl: 'https://gateway.studio.uat.mtm.video/chat'
  },

  versionCheckURL: 'https://studio.uat.mtm.video/version.json',
  healthCheckURL: 'https://gateway.studio.uat.mtm.video/mtm-manage/health',
  captchaSiteKey: '6LcDHiAsAAAAAAIdp754XkAn0p6X_6tBWnLIUvcC',
  sentry: {
    dsn: 'https://cc5da55be645245f9daca78ca30f6072@o4508692085145600.ingest.de.sentry.io/4508692413808720',
    enabled: false,
  },
	userflow: {
		token: 'userflow-token',
		enabled: false,
	},
  iam: {
    iamApiUrl: 'https://iam.studio.uat.mtm.video',
    appApiUrl: 'https://gateway.studio.uat.mtm.video',
    ssoCallbackUrl: '/sso/callback',
    ssoCallbackHost: 'https://studio.uat.mtm.video',
    authProcessUrl: '/entry/auth/process',
    resetPasswordCallbackUrl: '/entry/auth/reset',
    serviceUuid: '00e9b227-eb3a-4d96-bc68-5f0027cb785a',
    ssoUrl: {
      google: 'https://gateway.studio.uat.mtm.video/oauth2/authorization/google',
      azure: 'https://gateway.studio.uat.mtm.video/oauth2/authorization/azure',
    },
  },

  drive: {
    apiUrl: 'https://drive.svc.studio.uat.mtm.video',
  },

  admin: {
    apiUrl: 'https://admin.gtw.studio.uat.mtm.video/gtw',
  },

  context: {
    apiUrl: 'https://context.studio.uat.mtm.video',
  },
};
